import React from 'react';
import SkillEffectGroup from './SkillEffectGroup';
import SkillEffectDivider from './SkillEffectDivider';

/**
 * SkillEffectsList — Lista de todos los grupos de skill_effects.
 * Renderiza un SkillEffectGroup por cada group_id, con separadores OR entre ellos.
 * Props:
 *   skillEffects: array de objetos { group_id, effects, Conditions, Preconditions }
 */
const SkillEffectsList = ({ skillEffects }) => {
    if (!skillEffects || skillEffects.length === 0) {
        return null;
    }

    return (
        <div className="space-y-0">
            {/* Header de sección */}
            <div className="flex items-center gap-3 mb-4">
                <div className="h-px flex-1 bg-gray-200 dark:bg-gray-700" />
                <span className="text-[10px] font-bold uppercase tracking-widest text-gray-400 dark:text-gray-500 px-2">
                    Activation Logic
                </span>
                <div className="h-px flex-1 bg-gray-200 dark:bg-gray-700" />
            </div>

            {/* Grupos con divisores OR entre ellos */}
            <div className="space-y-1">
                {skillEffects.map((group, index) => (
                    <React.Fragment key={group.group_id ?? index}>
                        {/* Divisor OR entre grupos (no antes del primero) */}
                        {index > 0 && (
                            <SkillEffectDivider scenarioNumber={group.group_id ?? index + 1} />
                        )}
                        <SkillEffectGroup
                            group={group}
                            isFirst={index === 0}
                        />
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
};

export default SkillEffectsList;
